import * as React from 'react';

const Es24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#B5002A",
    d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#F4C327", d: "M3 15h18V9H3z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F4F4F4", d: "M9.712 11.08h.526v2.4h-.526z" }), /* @__PURE__ */ React.createElement("path", { fill: "#C60B1E", d: "M9.053 11.869h1.317v.263H9.053zm1.317 1.053-.79-.264v-.263l.79.264z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F4F4F4",
    d: "M6.947 11.08a.264.264 0 0 0-.263.263v1.71c0 .321.298.922 1.315.922s1.316-.601 1.316-.921v-1.711a.264.264 0 0 0-.264-.264z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#C60B1E",
    d: "M8 12.395H6.685v-1.053c0-.146.118-.264.263-.264h1.053zm.001 0h1.316v.658a.658.658 0 0 1-1.316 0z"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#CF995A", d: "M6.685 12.395H8v.658a.658.658 0 0 1-1.315 0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F4F4F4", d: "M5.764 11.08h.526v2.4h-.526z" }), /* @__PURE__ */ React.createElement("path", { fill: "#334B9E", d: "M5.5 13.712h1v.25h-1zm3.948 0h1v.25h-1z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#CF995A",
    d: "M7.592 10.394A.39.39 0 0 0 8 10.32a.39.39 0 0 0 .408.073.396.396 0 0 0 .777-.104.396.396 0 0 0-.54-.367A.396.396 0 0 0 8 9.73a.394.394 0 0 0-.645.193.393.393 0 0 0-.539.367.395.395 0 0 0 .776.104"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#C60B1E",
    d: "m7.21 10.816-.263-.264.155-.154a1.27 1.27 0 0 1 1.797 0l.155.154-.264.264zm-1.578 1.053h1.315v.263H5.632zm0 1.053.79-.264v-.263l-.79.264z"
  }
), /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 12.45, r: 0.5, fill: "#334B9E" }), /* @__PURE__ */ React.createElement("circle", { cx: 6.02, cy: 10.65, r: 0.25, fill: "#C60B1E" }), /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10.65, r: 0.25, fill: "#C60B1E" }));
Es24.Size = 24;
Es24.Title = "Es";

export { Es24 as default };
